import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import classnames from 'classnames';


import './navbar.scss';

const routeArr = [
	{
		path: '/',
		name: 'HOME',
	},
	{
		path: '/service',
		name: 'SERVICE',
	},
	{
		path: '/contact',
		name: 'CONTACT',
	},
];
const NavBar = ({ location }) => {
	const [show, setShow] = useState(true);

	useEffect(() => {
		const navbarToggle = () => {
			if (window.scrollY > 220) {
				setShow(false);
			} else {
				setShow(true);
			}
		};
		window.addEventListener('scroll', () => navbarToggle());

		return window.removeEventListener('scroll', navbarToggle);
	});

	return (
		<div
			className={classnames('nav-wrapper', {
				fixed: !show,
			})}
		>
			{routeArr.map((v, i) => (
				<>
					<Link
						className={classnames({
							active: location.pathname === v.path,
						})}
						to={v.path}
						key={i}
					>
						{v.name}
					</Link>
				</>
			))}
		</div>
	);
};

export default withRouter(NavBar);
